/* Bodi Refill Builder — mobile build-your-pack.
   A sticky/collapsible scent hero (swipeable) stays in sync with a scent card
   carousel; each card adds its scent as its own line item via AJAX. The hero
   glass panel (name/notes/blurb) is driven by the active (centred) scent. */
(function () {
  if (customElements.get('bodi-refill-builder')) return;

  class BodiRefillBuilder extends HTMLElement {
    connectedCallback() {
      this.min = parseInt(this.dataset.min || '1', 10);
      this.noun = this.dataset.noun || 'refills';
      this.nounSingular = this.noun.replace(/s$/, '');
      this.hero = this.querySelector('[data-brb-hero]');
      this.gallery = this.querySelector('[data-brb-gallery]');
      this.rail = this.querySelector('[data-brb-rail]');
      this.panel = this.querySelector('[data-brb-panel]');
      this.elName = this.querySelector('[data-brb-name]');
      this.elNotes = this.querySelector('[data-brb-notes]');
      this.elBlurb = this.querySelector('[data-brb-blurb]');
      this.elBarname = this.querySelector('[data-brb-barname]');
      this.pack = this.querySelector('[data-brb-pack]');
      this.atc = this.querySelector('[data-brb-atc]');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.brb-card'));
      this.qty = {};
      this.active = -1;
      this.syncing = false;

      this.cards.forEach((c) => this._wire(c));

      const toggle = this.querySelector('[data-brb-toggle]');
      if (toggle) toggle.addEventListener('click', () => this.hero.classList.toggle('is-collapsed'));

      this._onGScroll = this._debounced(() => { if (!this.syncing) this._setActive(this._nearest(this.gallery), 'gallery'); });
      this._onRScroll = this._debounced(() => { if (!this.syncing) this._setActive(this._nearest(this.rail), 'rail'); });
      if (this.gallery) this.gallery.addEventListener('scroll', this._onGScroll, { passive: true });
      if (this.rail) this.rail.addEventListener('scroll', this._onRScroll, { passive: true });

      if (this.atc) this.atc.addEventListener('click', () => this._addToCart());

      this._render();
      this._setActive(0, 'init');
    }

    _wire(card) {
      const id = card.dataset.vid;
      this.qty[id] = 0;
      const i = parseInt(card.dataset.idx, 10);
      const tap = card.querySelector('[data-brb-tap]');
      const add = card.querySelector('[data-brb-add]');
      const inc = card.querySelector('[data-brb-inc]');
      const dec = card.querySelector('[data-brb-dec]');
      if (tap) tap.addEventListener('click', () => { this.hero.classList.remove('is-collapsed'); this._setActive(i, 'tap'); });
      if (add && !add.disabled) add.addEventListener('click', () => { this.qty[id] = 1; this._syncCard(card); this._setActive(i, 'tap'); this._render(); });
      if (inc) inc.addEventListener('click', () => { this.qty[id]++; this._syncCard(card); this._render(); });
      if (dec) dec.addEventListener('click', () => { this.qty[id] = Math.max(0, this.qty[id] - 1); this._syncCard(card); this._render(); });
    }

    _syncCard(card) {
      const id = card.dataset.vid;
      const q = this.qty[id];
      const add = card.querySelector('[data-brb-add]');
      const stepper = card.querySelector('[data-brb-stepper]');
      const qtyEl = card.querySelector('[data-brb-qty]');
      if (q > 0) { if (add) add.hidden = true; if (stepper) stepper.hidden = false; if (qtyEl) qtyEl.textContent = q; }
      else { if (add) add.hidden = false; if (stepper) stepper.hidden = true; }
    }

    _debounced(fn) {
      let r;
      return () => { cancelAnimationFrame(r); r = requestAnimationFrame(fn); };
    }

    _nearest(c) {
      const mid = c.scrollLeft + c.clientWidth / 2;
      let b = 0, bd = Infinity;
      Array.prototype.forEach.call(c.children, (el, i) => {
        const cc = el.offsetLeft + el.clientWidth / 2, d = Math.abs(cc - mid);
        if (d < bd) { bd = d; b = i; }
      });
      return b;
    }

    _scrollTo(c, i, smooth) {
      const el = c.children[i];
      if (!el) return;
      c.scrollTo({ left: el.offsetLeft - (c.clientWidth - el.clientWidth) / 2, behavior: smooth ? 'smooth' : 'auto' });
    }

    _setActive(i, src) {
      const card = this.cards[i];
      if (!card) return;
      if (i !== this.active) {
        this.active = i;
        if (this.elName) this.elName.textContent = card.dataset.name || '';
        if (this.elNotes) this.elNotes.textContent = card.dataset.notes || '';
        if (this.elBlurb) this.elBlurb.textContent = card.dataset.blurb || '';
        if (this.elBarname) this.elBarname.textContent = card.dataset.name || '';
        if (this.panel) { this.panel.classList.remove('pop'); void this.panel.offsetWidth; this.panel.classList.add('pop'); }
        this.cards.forEach((c, idx) => c.classList.toggle('is-active', idx === i));
      }
      this.syncing = true;
      clearTimeout(this._syncT);
      if (src !== 'gallery' && this.gallery) this._scrollTo(this.gallery, i, src === 'tap');
      if (src !== 'rail' && this.rail) this._scrollTo(this.rail, i, src === 'tap');
      this._syncT = setTimeout(() => { this.syncing = false; }, 150);
    }

    _total() { let n = 0; for (const id in this.qty) n += this.qty[id]; return n; }
    _totalCents() {
      let c = 0;
      this.cards.forEach((card) => { c += (this.qty[card.dataset.vid] || 0) * parseInt(card.dataset.price || '0', 10); });
      return c;
    }

    _render() {
      const t = this._total();
      if (!this.atc) return;
      const remaining = Math.max(0, this.min - t);
      let packText = '';
      if (t === 0) {
        packText = this.min > 1 ? 'Pick at least ' + this.min + ' ' + this.noun : '';
        this.atc.disabled = true;
        this.atc.textContent = this.min > 1 ? 'Add ' + this.min + ' to start' : 'Pick a scent';
      } else if (remaining > 0) {
        packText = remaining + ' more to go — ' + t + ' in your pack';
        this.atc.disabled = true;
        this.atc.textContent = 'Add ' + remaining + ' more';
      } else {
        packText = ''; // minimum reached — the pack line is no longer needed
        this.atc.disabled = false;
        this.atc.textContent = 'Add to cart · $' + (this._totalCents() / 100).toFixed(2);
      }
      if (this.pack) { this.pack.textContent = packText; this.pack.style.display = packText ? '' : 'none'; }
    }

    _addToCart() {
      const items = [];
      for (const id in this.qty) if (this.qty[id] > 0) items.push({ id: Number(id), quantity: this.qty[id] });
      if (!items.length || this._total() < this.min) return;
      this.atc.disabled = true;
      this.atc.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then((r) => { if (!r.ok) throw new Error('add failed'); window.location.href = '/cart'; })
        .catch(() => { this.atc.disabled = false; this.atc.textContent = 'Try again'; });
    }
  }

  customElements.define('bodi-refill-builder', BodiRefillBuilder);
})();
